export enum SpinNotificationType {
    NONE = 'none',
    SUCCESS = 'usersettings.weconnect.spin.change.confirmation',
    SYSTEM_ERROR = 'usersettings.weconnect.spin.systemerror.feedback',
    CURRENT_MATCHES_NEW_SPIN_ERROR = 'usersettings.weconnect.spin.invalidpin.feedback',
    CURRENT_SPIN_INCORRECT_ERROR = 'usersettings.weconnect.spin.invalidcurrentpin.feedback',
    CONSECUTIVE_NUMBERS_ERROR = 'usersettings.weconnect.spin.consecutiveNumbers.feedback',
    EQUAL_NUMBERS_ERROR = 'usersettings.weconnect.spin.sameNumbers.feedback',
    MISMATCHING_SPIN_ERROR = 'usersettings.weconnect.spin.mismatch.feedback'
}